export const USER_BASE_PATH = '/user';

export const USER_SIGNIN_PATH = USER_BASE_PATH + '/signin';

export const USER_SIGNUP_PATH = USER_BASE_PATH + '/signup';

export const USER_ACCOUNT_ACTIVATION_PATH = USER_BASE_PATH + '/onboarding';

export const USER_FORGOT_PASSWORD_PATH = USER_BASE_PATH + '/forgot-password';

export const USER_CASES_PATH = USER_BASE_PATH + '/cases';

export const USER_ORDERS_PATH = USER_BASE_PATH + '/orders';

export const USER_ORDER_DETAIL_PATH = USER_BASE_PATH + '/order/details/:id';

export const USER_PRODUCTS_PATH = USER_BASE_PATH + '/products';

export const USER_SUBSCRIPTIONS_PATH = USER_BASE_PATH + '/subscriptions';

export const USER_SUBSCRIPTION_DETAIL_PATH = USER_BASE_PATH + '/subscription/details/:id';

export const USER_CONTACTS_PATH = USER_BASE_PATH + '/contacts';

export const USER_PROFILE_PATH = USER_BASE_PATH + '/profile';

export const USER_CHAT_PATH = USER_BASE_PATH + '/chat/:type?';

export const USER_FAQS_PATH = USER_BASE_PATH + '/faqs';

export const USER_AFFILIATE_PATH = USER_BASE_PATH + '/affiliate-program';

export const USER_LAB_WORK_PATH = USER_BASE_PATH + '/lab-work';

export const USER_MY_LABS_PATH = USER_BASE_PATH + '/my-labs';

export const USER_CHECKOUT_SUCCESS_PATH = USER_BASE_PATH + '/checkout/success';

export const USER_CHECKOUT_CANCEL_PATH = USER_BASE_PATH + '/checkout/cancel';

export const USER_VERIFY_EMAIL_PATH = USER_BASE_PATH + '/verify-email';

export const USER_INTAKE_PATH = '/intake/:id';

export const USER_VOUCHER_INTAKE_PATH = '/voucher-intake/:id';
